import {CasinofiedApplicationBase} from "../casinofied-application-base";
import {IDivHostedAppInitParameters} from "@sparkware/uc-sdk-core";

export class BonusWheelApplication extends CasinofiedApplicationBase {
    private _bonusWheelContainerElement: HTMLElement | null = null;
    protected _showApp(initParams: IDivHostedAppInitParameters) {
        this._bonusWheelContainerElement = this.services.dom.createElement('div');
        this._bonusWheelContainerElement.id = this._openAppData.launchInfo.containerID;
        this.services.dom.body.appendChild(this._bonusWheelContainerElement);
        super._showApp(initParams);
    }

    dispose() {
        super.dispose();
        try {
            this._bonusWheelContainerElement?.remove();
        } catch (err) {
            this.services.logger.error('Failed to remove bonus wheel container element', err);
        }
    }
}